module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter111",
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("I ran out of room so to be brief, for once, thanks to: agent extraordinaire Kate Epstein, editor Katie Anderson, daughter Katie Temple (notice a theme here?), and all of the addicted knitters who turned a hobby into a community. Sincerely, you all rock.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594e2f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740793271_epub_ack_r1.vue
// module id = 63
// module chunks = 0